
import {Component, Prop, Vue} from "vue-property-decorator";
import AuditTrailTable from "@/components/audittrail/AuditTrailTable.vue";
import {auditTrailModule, currentUserModule, studyInstitutesModule} from "@/store";
import {formatDateTime} from "@/auxillary/date-format";

@Component({
  components: {AuditTrailTable}
})
export default class StudyPatientAuditTrailView extends Vue {
  @Prop({default: ""}) private studyInstituteId: string;

  get studyInstitute() {
    return studyInstitutesModule.currentStudyInstitute;
  }

  get studyInstituteIdentifier() {
    return this.studyInstitute?.identifier ?? "";
  }

  get studyInstituteDisplayName() {
    return this.studyInstitute?.displayName ?? "";
  }

  get currentUserDetails() {
    return (currentUserModule.user?.userName ?? "") + " (" + (currentUserModule.roleIdentifier ?? "") + ") " + formatDateTime((new Date().toUTCString()))
  }

  get changes() {
    return auditTrailModule.auditChanges ?? [];
  }

  async mounted() {
    await currentUserModule.loadIfEmpty();
    await studyInstitutesModule.getStudyInstituteById(this.studyInstituteId);
    await auditTrailModule.loadForStudyInstitute(this.studyInstituteId)
  }

  async back() {
    await this.$router.push({
      name: "institutesoverview"
    }).catch();
  }
}
